module.exports = __webpack_public_path__ + "static/media/playButton.8a8d9d38.svg";